import { render, staticRenderFns } from "./SortableHead.vue?vue&type=template&id=1fc19786&scoped=true&"
import script from "./SortableHead.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SortableHead.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SortableHead.vue?vue&type=style&index=0&id=1fc19786&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc19786",
  null
  
)

export default component.exports